import React from "react";
import InputWrapper from "../../Inputs/InputWrapper";
import FloatingLabelInput from "../../Inputs/FloatingLabelInput";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import * as Form from "@radix-ui/react-form";
import { formatToPhone } from "./phoneHelpers";
import { SignUpFormData } from "../../../../SignUpFormTypes/signUpFormTypes";
import { useState } from "react";

const PhoneInput = () => {
  const { control } = useFormContext<SignUpFormData>();
  const [isFocused, setIsFocused] = useState(false);
  const INPUT_NAME = "phone";

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.phone}
      control={control}
      render={({
        field: { value, onBlur, ...field },
        fieldState: { invalid, isTouched, isDirty },
      }) => (
        <InputWrapper
          errorMsg="Please enter a valid phone number"
          hasError={invalid && isTouched}
          label="Mobile phone"
          valid={!invalid && isDirty}
          valueExists={!!value}
          name={INPUT_NAME}
        >
          <FloatingLabelInput
            hasError={invalid && isTouched}
            maxLength={16}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setTimeout(() => {
                setIsFocused(false);
                onBlur();
              }, 180);
            }}
            autoComplete="tel-national"
            value={formatToPhone(value)}
            {...field}
          />
          {isFocused && (!invalid || !isTouched) && (
            <Form.Message className="text-forest-600 font-normal text-base leading-160 not-italic leading-[160%]">
              For text verification to access your account.
            </Form.Message>
          )}
        </InputWrapper>
      )}
    />
  );
};

export default PhoneInput;
